export default __webpack_public_path__ + "static/media/banner_left_circle.7516f88c.gif";